import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { AudioPlayerService } from '../../services/audio-player.service';
import { GameService } from '../../services/game.service';
import { GameClicker } from '../../_models/model';
import { IGameComponent } from '../game/game.component';

export interface IGameResults {
   completed: boolean;
   foundBroedels: number;
}

@Component({
  selector: 'app-game-clicker',
  templateUrl: './game-clicker.component.html',
  styleUrls: ['./game-clicker.component.less']
})
export class GameClickerComponent implements OnInit, IGameComponent<GameClicker> {
  game!: GameClicker;
  @Input() activeLevelId!: number;
  @Output() closeEvent = new EventEmitter<boolean>()
  started = false;
  showIntro = true;
  showComplete = false;
  foundBroedels = 0;
  replayCounter= 0;
  resultText= '';
  introText?: SafeHtml;
  mode: 'beginner' | 'expert' = 'beginner';
  captionBeginner: SafeHtml = this.audio.text.games.clicker_beginner;
  captionExpert: SafeHtml = this.audio.text.games.clicker_expert;

  constructor(private gameService: GameService, private audio: AudioPlayerService) {
    this.introText = audio.getPlayHTML('game_zoek_intro');
  }

  setGame(game: GameClicker) {
    this.game = game;
    this.activeLevelId = game.levelNumber;
  }

  ngOnInit(): void {
    this.showIntro = true;
    this.started = false;
    this.showComplete = false;

  }
  start(mode: 'beginner' | 'expert') {
    this.mode = mode;
    this.showIntro = false;
    this.started = true;
    // this.audio.play('zoek_music')
    this.audio.stop();
    // this.audio.stopMusic();
    this.audio.playMusic();
  }
  completed(result: IGameResults) {
    this.audio.stop();
    this.audio.stopMusic();
    this.showComplete = true;
    this.foundBroedels = result.foundBroedels;
    if (this.foundBroedels === 1) {
      this.resultText = this.audio.text.games.clicker_response.replace('{{foundBroedels}}', this.foundBroedels.toString());
    }  else {
      this.resultText = this.audio.text.games.clicker_response_plural.replace('{{foundBroedels}}', this.foundBroedels.toString());
    }

    this.gameService.setLevelProgress(this.game.levelElement.uuid, '', true);
    this.audio.playSoundGameFinished();

    // Show message after 3 seconds
    setTimeout(() => {
      this.audio.play('game_afgerond');
    }, 3 * 1000);
  }
  exit() {

    this.closeEvent.emit(false);
  }
  replay() {
    this.showIntro = true;
    this.replayCounter++;
    this.showComplete = false;
    // this.audio.play('zoek_music')
    // this.audio.stopMusic();
  }
}
